// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"_ad6b36a"};